import { useEffect, useMemo, useState } from "react";

import { formAtom } from "@impero-com/common/utils/form/formAtom";
import { FormAtom } from "@impero-com/common/utils/form/formAtom/types";
import { atom, useAtomValue } from "jotai";
import * as Yup from "yup";

/**
 * Bridge from RHF controller value → local FormAtom for atom-based sub-components.
 * Atom changes sync back to RHF via setValue.
 */
export function useRHFAdapterAtom<T>(
    fields: T,
    setValue: (value: T) => void,
    schema: Yup.Schema<T>
): FormAtom<T> {
    const [fieldsAtom] = useState(() => atom(fields));
    const fieldsFormAtom = useMemo(
        () => formAtom(fieldsAtom, schema),
        [fieldsAtom, schema]
    );
    const atomValue = useAtomValue(fieldsFormAtom);

    useEffect(() => {
        setValue(atomValue);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [atomValue]);
    return fieldsFormAtom;
}
